<template>
    <div class="servicePlanBooking">
        <div class="servicePlanBooking__tabs">
            <button type="button"
                    class="servicePlanBooking__tab"
                    :class="{ 'servicePlanBooking__tab--active': type.value === vehicleType }"
                    v-for="type in vehicleTypes"
                    :key="type.value"
                    @click="onVehicleType(type.value)"
            >
                <Component :is="type.logo" :is-white="type.value === vehicleType" v-if="type.logo" />
                <span :class="{ 'sr-only': type.logo }">{{ type.label }}</span>
            </button>
        </div>

        <div class="servicePlanBooking__wrap">
            <div class="servicePlanBooking__body">
                <form class="servicePlanBooking__form" @submit.prevent="onSubmit">
<!--                    <div class="servicePlanBooking__row">-->
<!--                        <label for="vrm" class="sr-only">Registration number</label>-->
<!--                        <div class="servicePlanBooking__inputWrap">-->
<!--                            <input type="text"-->
<!--                                   name="reg_num"-->
<!--                                   id="vrm"-->
<!--                                   v-model="vrm"-->
<!--                                   placeholder="Enter vehicle reg"-->
<!--                                   class="servicePlanBooking__input"-->
<!--                            />-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    <div class="servicePlanBooking__row">-->
<!--                        <label for="mileage" class="sr-only">Mileage</label>-->
<!--                        <div class="servicePlanBooking__inputWrap">-->
<!--                            <input type="number"-->
<!--                                   name="mileage"-->
<!--                                   id="mileage"-->
<!--                                   v-model.number="mileage"-->
<!--                                   placeholder="Enter mileage"-->
<!--                                   class="servicePlanBooking__input"-->
<!--                            />-->
<!--                        </div>-->
<!--                    </div>-->

                    <div class="servicePlanBooking__row">
                        <label for="location" class="sr-only">Location</label>
                        <div class="servicePlanBooking__selectWrap">
                            <select name="location"
                                    id="location"
                                    class="servicePlanBooking__select"
                                    v-model="location"
                                    @change="onChange"
                            >
                                <option value="">Location</option>
                                <option :value="location.id" v-for="location in locationsByVehicleType">
                                    {{ location.name }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <button type="submit" class="servicePlanBooking__button" :disabled="isFormDisabled">
                        Buy now
                    </button>
                </form>

                <div class="servicePlanBooking__footer"
                     v-if="formContent"
                     v-html="formContent"
                >

                </div>
            </div>
        </div>

        <SPBOverlay
            :is-open="isOverlayOpen"
            ref="overlay"
            @close="isOverlayOpen = !isOverlayOpen"
        >
            <div id="servicePlanBookingIframeContainer" />
        </SPBOverlay>
    </div>
</template>

<script>
import BMWLogo from '../../global/components/icons/brands/BMWLogo.vue'
import CarzLogo from '../../global/components/icons/brands/CarzLogo.vue'
import LandRoverLogo from '../../global/components/icons/brands/LandRoverLogo.vue'
import MiniLogo from '../../global/components/icons/brands/MiniLogo.vue'
import JaguarLogo from '../../global/components/icons/brands/JaguarLogo.vue'
import SPBOverlay from './SPBOverlay.vue'

export default {
    components: {
        SPBOverlay,
        BMWLogo,
        CarzLogo,
        LandRoverLogo,
        MiniLogo,
        JaguarLogo,
    },
    props: {
        utmMedium: {
            type: String,
            default: ''
        },
        utmCampaign: {
            type: String,
            default: ''
        },
        utmSource: {
            type: String,
            default: ''
        },
        locations: {
            type: Array,
            default: () => []
        },
        formContent: {
            type: String
        }
    },
    data() {
        return {
            vehicleType: 'carz',
            vrm: '',
            mileage: '',
            location: '',
            isOverlayOpen: false,
            isEmacScriptLoaded: false,
        }
    },
    methods: {
        onVehicleType(value) {
            this.vehicleType = value
            this.location = ''
        },
        async onSubmit() {
            if (!this.isEmacScriptLoaded) {
                await this.loadEmacScript()
            }

            if (this.isFormDisabled) {
                return
            }

            if (!this.selectedLocation) {
                return
            }

            try {
                const res = await fetch(`/sites/petervardy/templates/ajax/servicing/emac_form_overlay.php?token=${this.selectedLocation.emac_token}`)
                const html = await res.text()
                this.isOverlayOpen = true

                // 300ms transition
                setTimeout(() => {
                    const container = this.$refs.overlay.$el.querySelector('#servicePlanBookingIframeContainer')

                    if (container) {
                        container.innerHTML = html
                    }
                }, 300)
            } catch (e) {}
        },
        async loadEmacScript() {
            if (this.isEmacScriptLoaded) {
                return
            }

            return new Promise((res) => {
                const script = document.createElement('script')
                script.src = 'https://emac-direct.service-plan.co.uk/static/js/init.js'
                script.async = true
                script.onload = res
                document.querySelector('body').appendChild(script)
            })
        },
        onChange() {
            this.loadEmacScript()
        }
    },
    computed: {
        vehicleTypes() {
            return [
                {
                    label: 'CARZ',
                    value: 'carz',
                    logo: 'CarzLogo'
                },
                {
                    label: 'BMW',
                    value: 'bmw',
                    logo: 'BMWLogo'
                },
                {
                    label: 'Jaguar',
                    value: 'jaguar',
                    logo: 'JaguarLogo'
                },
                {
                    label: 'Land Rover',
                    value: 'land-rover',
                    logo: 'LandRoverLogo'
                },
                {
                    label: 'MINI',
                    value: 'mini',
                    logo: 'MiniLogo'
                }
            ]
        },
        selectedVehicleType() {
            return this.vehicleTypes.find((v) => v.value === this.vehicleType)
        },
        locationsByVehicleType() {
            return this.locations
                .filter((l) => l.name.toLowerCase().includes(this.selectedVehicleType.label.toLowerCase()))
                .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
        },
        isFormDisabled() {
            return this.location === ''
            return this.vrm === '' || this.mileage === '' || this.location === ''
        },
        selectedLocation() {
            const location = this.locations.find((l) => l.id === this.location)

            if (!location) {
                return null
            }

            return location
        }
    }
}
</script>